// extracted by mini-css-extract-plugin
export var icon = "_ay-3";
export var subtitle = "_ay-2";
export var title = "_ay-1";
export var value = "_ay-0";